import api from './api';

export const vendorService = {
  // Get all vendors
  getAllVendors: (params) => api.get('/vendors', { params }),

  // Get vendor by ID
  getVendorById: (id) => api.get(`/vendors/${id}`),

  // Create vendor
  createVendor: (vendorData) => api.post('/vendors', vendorData),

  // Update vendor
  updateVendor: (id, vendorData) => api.put(`/vendors/${id}`, vendorData),

  // Delete vendor
  deleteVendor: (id) => api.delete(`/vendors/${id}`)
};

